import type { ComponentType } from 'react';
import React, { PureComponent } from 'react';

import { Consumer } from './context';

function withGeoInfo<P extends object>(Component: ComponentType<P>): ComponentType<P> {
    const displayName = Component.displayName || Component.name || 'Component';

    class GeoInfo extends PureComponent {
        static displayName = `WithGeoInfo(${displayName})`;

        render() {
            return <Consumer>{geo => <Component {...(this.props as P)} geo={geo} />}</Consumer>;
        }
    }

    return GeoInfo as ComponentType<P>;
}

export { withGeoInfo };
